var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5989 0L14.4869 7.50198L16.3649 3.07599L24.5989 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.27893 0L11.2989 7.57298L9.51292 3.07599L1.27893 0Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.9639 17.3906L18.2739 21.5126L24.0299 23.0956L25.6749 17.4816L20.9639 17.3906Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.212891 17.4816L1.84789 23.0956L7.60387 21.5126L4.92388 17.3906L0.212891 17.4816Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.28906 10.4259L5.68506 12.8529L11.391 13.1069L11.198 6.96387L7.28906 10.4259Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.5889 10.4256L14.6189 6.89258L14.4869 13.1066L20.1929 12.8526L18.5889 10.4256Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.604 21.5134L11.046 19.8374L8.081 17.5234L7.604 21.5134Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.832 19.8374L18.274 21.5134L17.797 17.5234L14.832 19.8374Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.274 21.5129L14.832 19.8369L15.106 22.0809L15.076 23.0249L18.274 21.5129Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.604 21.5129L10.802 23.0249L10.782 22.0809L11.046 19.8369L7.604 21.5129Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.60394 21.5126L8.10094 17.3906L4.92395 17.4816L7.60394 21.5126Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.777 17.3906L18.274 21.5126L20.964 17.4816L17.777 17.3906Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.1929 12.8525L14.4869 13.1065L15.0149 16.0395L15.8579 14.2735L17.8879 15.1975L20.1929 12.8525Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.00006 15.1975L10.0201 14.2735L10.8631 16.0395L11.391 13.1065L5.68506 12.8525L8.00006 15.1975Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M5.68506 12.8525L8.08106 17.5225L8.00006 15.1975L5.68506 12.8525Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M17.888 15.1975L17.797 17.5225L20.193 12.8525L17.888 15.1975Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.391 13.1074L10.863 16.0404L11.533 19.5024L11.675 14.9444L11.391 13.1074Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M14.4869 13.1074L14.2129 14.9344L14.3449 19.5024L15.0149 16.0404L14.4869 13.1074Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M15.015 16.0402L14.345 19.5022L14.832 19.8372L17.797 17.5232L17.888 15.1982L15.015 16.0402Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M7.99988 15.1982L8.08088 17.5232L11.0459 19.8372L11.5329 19.5022L10.8629 16.0402L7.99988 15.1982Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M15.076 23.0247L15.106 22.0807L14.853 21.8577H11.025L10.782 22.0807L10.802 23.0247L7.604 21.5127L8.721 22.4257L10.995 23.9997H14.883L17.157 22.4257L18.274 21.5127L15.076 23.0247Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M14.832 19.837L14.345 19.502H11.533L11.046 19.837L10.782 22.0809L11.025 21.8579H14.853L15.106 22.0809L14.832 19.837Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M25.025 7.98998L25.878 3.84799L24.599 0L14.832 7.24898L18.589 10.426L23.898 11.98L25.066 10.609L24.558 10.244L25.37 9.50198L24.751 9.01498L25.563 8.39598L25.025 7.98998Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M0 3.84799L0.862999 7.98998L0.315 8.39598L1.127 9.01498L0.507999 9.50198L1.32 10.244L0.811999 10.609L1.98 11.98L7.28898 10.426L11.046 7.24898L1.279 0L0 3.84799Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M23.898 11.9798L18.589 10.4258L20.193 12.8528L17.797 17.5228L20.964 17.4818H25.675L23.898 11.9798Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M7.28888 10.4258L1.97989 11.9798L0.212891 17.4818H4.92388L8.08087 17.5228L5.68488 12.8528L7.28888 10.4258Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M14.4869 13.1072L14.8319 7.24916L16.3649 3.07617H9.51294L11.0459 7.24916L11.3909 13.1072L11.5229 14.9541L11.5329 19.5021H14.3449L14.3549 14.9541L14.4869 13.1072Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M10.8629 16.0394L7.99988 15.1974L10.0199 14.2734L10.8629 16.0394Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M15.015 16.0394L15.858 14.2734L17.888 15.1974L15.015 16.0394Z",
    fill: "#233447"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.5881ff86414206f03ae4dedd0e5e1f8b.svg";
export { ForwardRef as ReactComponent };